/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-PeoplePicker{width:100%}.ms-SearchBoxSmallExample{width:208px}\n"}]);